import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogComponent } from '../a2p/common/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class NotifyService {
  private snackBar = inject(MatSnackBar);
  private dialog = inject(MatDialog);

  public notify(message: string, action = 'Close') {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  public confirm(title: string, message: string): void {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title,
        message,
        hideCancel: true,
      },
    });
  }
}
